// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    takeLatest
} from 'redux-saga/effects';

import {
    getDeviceEligibilityData
} from './../../../store/deviceInfo/eligibility';

import { getClaimDetails, getDeviceInfoData } from './../../../store/deviceInfo/deviceInfo';
import { fetchDeviceInfo } from './deviceInfoSagas';
import { fetchDeviceEligibility } from './deviceEligibilitySagas';
import { fetchClaimDetails } from './claimDetailSagas';

export default [
    takeLatest(`${getDeviceInfoData}`, fetchDeviceInfo),
    takeLatest(`${getDeviceEligibilityData}`, fetchDeviceEligibility),
    takeLatest(`${getClaimDetails}`, fetchClaimDetails),
];
